import useStore from '@/store/pinia'
const { userStore, HsystemStore } = useStore()
export function shareList () {
  const haierShareList = [
    { typeName: '相机', image: 'https://obs.pricoo.pk/62f4d8a6.png', url: 'https://www.instagram.com/haierpakistanofficial/?igshid=hwas1ju5g2d'},
    { typeName: 'footBook', image: 'https://obs.pricoo.pk/da147d5a.png', url: 'https://www.facebook.com/HaierPakistan/'},
    { typeName: '飞书', image: 'https://obs.pricoo.pk/6447332f.png', url: 'https://twitter.com/HaierPakistan/'},
  ]
  const pricooShareList = [
    { typeName: '相机', image: 'https://obs.pricoo.pk/62f4d8a6.png', url: 'https://www.instagram.com/pricoo.pk/', },
    { typeName: 'footBook', image: 'https://obs.pricoo.pk/da147d5a.png', url: 'https://www.facebook.com/PricooOfficial'},
    { typeName: 'linkedin', image: 'https://obs.pricoo.pk/0d06986e.png', url: 'https://www.linkedin.com/company/pricoo-pk/' },
  ]
  return userStore.appHomeName === 'PRICOO' ? pricooShareList : haierShareList
}

export const paymentList = [
  { type: 'COD', typeName: 'cash-on-delivery', name: '货到付款', url: require('@/assets/imgs/payment/cod.png'), btnName: 'Cash On Delivery', width: 25 },
  { type: 'EASY_PAISA', typeName: 'easy-paisa', name: 'EasyPaisa', url: require('@/assets/imgs/payment/easy-paisa.png'), btnName: 'EasyPaisa', width: 28 },
  { type: 'JAZZ_CASH', typeName: 'jazzcash', name: 'jazzcash', url: require('@/assets/imgs/payment/jazzcash.png'), btnName: 'JazzCash', width: 56 },
  { type: 'CARD', typeName: 'card', name: '卡支付', url: require('@/assets/imgs/payment/card.png'), btnName: 'Credit/Debit Card', width: 32 }
]

export const footIcoList = {
  haierIco: { url: 'https://obs.pricoo.pk/047c2fe7.png', urlBlack: 'https://obs.pricoo.pk/69f2fa0d.png' },
  kefuIco: { url: 'https://obs.pricoo.pk/f5352afb.png', urlBlack: 'https://obs.pricoo.pk/f7f06aaf.png' }
}

export const footerInstList = [
  { typeName: 'Fast Express Delivery', introduce: 'Fast Express Delivery', image: 'https://obs.pricoo.pk/28ee7d06.png' },
  { typeName: 'Free Shipping', introduce: 'Free Shipping', image: 'https://obs.pricoo.pk/49f7b4fa.png' },
  { typeName: 'Secure Payment', introduce: 'Secure Payments <br/> Card Online Transfer', image: 'https://obs.pricoo.pk/f74c433f.png' },
  { typeName: 'Easy Return', introduce: 'Easy Return & Refund <br/> 7 Days In Case of Damage Units', image: 'https://obs.pricoo.pk/5eef5c7e.png' },
  { typeName: 'Quick Response', introduce: 'Hassle Free Service', image: 'https://obs.pricoo.pk/93e81028.png' },
  { typeName: 'Original Products', introduce: '100% Original Product', image: 'https://obs.pricoo.pk/a453de80.png' },
  { typeName: 'Discounts', introduce: 'Payments & Discounts', image: 'https://obs.pricoo.pk/add299b9.png' }
]

const haierFooterList = [
  {
    title: 'HOUSEHOLD',
    list: []
  },
  {
    title: 'CUSTOMER CARE',
    list: [
      { typeName: 'Press/Media', introduce: '', image: '', url: 'https://www.haier.com/pk/about-haier/news/' },
      { typeName: 'Contact Us', introduce: '', image: '', url: '/contactUs' },
      { typeName: 'Product Registration', introduce: '', image: '', url: 'https://www.haier.com/pk/service-support/product-registration/' },
      { typeName: 'Service Appointment', introduce: '', image: '', url: 'https://www.haier.com/pk/service-support/service-appointment/' },
      { typeName: 'Warranty Declaration', introduce: '', image: '', url: 'https://www.haier.com/pk/service-support/warranty-declaration/' },
      { typeName: 'Troubleshooting', introduce: '', image: '', url: 'https://www.haier.com/pk/service-support/self-service/' },
      { typeName: 'Demo Videos', introduce: '', image: '', url: 'https://www.haier.com/pk/service-support/demo-video/' },
      { typeName: 'Manual Download', introduce: '', image: '', url: 'https://www.haier.com/pk/service-support/product-guide/' }
    ]
  },
  {
    title: 'HAIER',
    list: [
      { typeName: 'Haier PK', introduce: '', image: '', url: 'https://www.haier.com/pk/about-haier/haier-pk/' },
      { typeName: 'Media kit', introduce: '', image: '', url: 'https://www.haier.com/pk/media-kit/' },
      { typeName: 'About Us', introduce: '', image: '', url: 'https://www.haier.com/pk/about-haier/haier-pk/' },
      { typeName: 'Blog', introduce: '', image: '', url: '/blogs' },
      // { typeName: 'Track Order', introduce: '', image: '', url: '' },
      { typeName: 'Terms & Condition', introduce: '', image: '', url: '/PrivacyPolicy?type=TERMS_CONDITIONS' },
      { typeName: 'Privacy Policy', introduce: '', image: '', url: '/PrivacyPolicy?type=USER_PRIVACY' }
      // { typeName: 'Cookie Policy', introduce: '', image: '', url: '' },
      // { typeName: 'Sitemap', introduce: '', image: '', url: '' },
    ]
  }
]

const pricooFooterList = [
  {
    title: 'Company Info',
    list: [
      { typeName: 'About Pricoo', introduce: '', image: '', url: '/aboutPricoo' },
      { typeName: 'Contact Us', introduce: '', image: '', url: '/contactUs' }
    ]
  },
  {
    title: 'Customer Service',
    list: [
      { typeName: 'Return & Refund policy', introduce: '', image: '', url: '' },
      { typeName: 'Shipping', introduce: '', image: '', url: '' },
      { typeName: 'Delivery Guarantee', introduce: '', image: '', url: '' },
      { typeName: 'Pricoo’s Commitments', introduce: '', image: '', url: '' }
    ]
  },
  {
    title: 'Help',
    list: [
      { typeName: 'Support & FAQ', introduce: '', image: '', url: '' },
    ]
  }
]

export function getFooterList() {
  const { userStore } = useStore()
  return userStore.appHomeName === 'PRICOO' ? pricooFooterList : haierFooterList
}
